import ImgixClient from '@imgix/js-core'
// refs. https://docs.imgix.com/libraries/imgix-core-js

export type ImageExtension = 'jpg' | 'png' | 'gif' | 'JPG' | 'PNG' | 'GIF'

export const isImageExtension = (
  extString: string
): extString is ImageExtension =>
  ['jpg', 'png', 'gif'].includes(extString.toLowerCase())

type Settings = {
  width: Maybe<number>
  height: Maybe<number>
  extension: Maybe<ImageExtension>
}

export type FlexImage = {
  filename: string
  path: string

  clone: () => FlexImage
  size: (size: Pick<Settings, 'width' | 'height'>) => FlexImage
  extension: (extension: ImageExtension) => FlexImage
  toString: () => string
  toFacefitUrlString: () => string
}

export const generateFlexImage = (
  domain: string,
  path: string,
  _settings?: Settings
): FlexImage => {
  const imgix = new ImgixClient({ domain })
  const settings = _settings || {
    width: undefined,
    height: undefined,
    extension: undefined,
  }
  const width = settings.width
  const height = settings.height
  const extension = settings.extension ?? 'jpg'

  return {
    // 触らないし流石にこれくらいはいい
    // eslint-disable-next-line fp/no-mutating-methods
    filename: path.split('/').pop() ?? '',
    path,
    clone() {
      return generateFlexImage(domain, path, settings)
    },
    size(size) {
      return generateFlexImage(domain, path, {
        ...settings,
        ...size,
      })
    },
    extension(extension) {
      return generateFlexImage(domain, path, {
        ...settings,
        extension,
      })
    },
    toString() {
      return imgix.buildURL(path, {
        w: width,
        h: height,
        ext: extension,
      })
    },
    toFacefitUrlString() {
      return imgix.buildURL(path, {
        w: width,
        h: height,
        ext: extension,
        fit: 'facearea',
        facepad: 3,
        // TODO: mask: ellipseは表示側でやれ
      })
    },
  }
}
